import RegistrationModal from './RegistrationModal';
export default RegistrationModal;